module.exports = __webpack_public_path__ + "static/media/madfit-5.716b38ac.jpg";